import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { LAB_TASK_STATUS } from "./apiRoutes";

interface LabTaskStatusItem {
  _id: string;
  totalTasks: number;
  openTasks: number;
  closedTasks: number;
  schoolName: string;
}

interface LabTaskStatusResponse {
  status: number;
  error: boolean;
  count: number;
  issues: any[];
  message: string;
  data: {
    items: LabTaskStatusItem[];
  };
}

const fetchLabStatusTracker = async (): Promise<LabTaskStatusResponse> => {
  const response = await axiosAuth.get<LabTaskStatusResponse>(LAB_TASK_STATUS);
  return response.data;
};

export const useGetLabTaskStatusQuery = (
  queryParams?: UseQueryOptions<
    LabTaskStatusResponse,
    Error,
    LabTaskStatusResponse,
    ["labTaskStatus"]
  >
) =>
  useQuery<LabTaskStatusResponse, Error, LabTaskStatusResponse, ["labTaskStatus"]>({
    queryKey: ["labTaskStatus"],
    queryFn: fetchLabStatusTracker,
    ...(queryParams as any),
  });
